<section fxLayoutAlign="center">
  <img alt="aodocs" src="assets/img/aodocs_logo.svg">
</section>
